export const actions = {
  token: "token",
  getToken: "getToken"
};
